import { MetaProvider } from '@solidjs/meta'
import type { Component } from 'solid-js'

export const withMeta = (component: Component) => () => (
  <MetaProvider>
    {component({})}
  </MetaProvider>
)
